module.exports = __webpack_public_path__ + "static/media/HowItWorks.ee60d283.jpg";